import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { Input, Select, Button, Form, Spin } from 'antd'; // Adjust the import according to your UI library

export const CloseIcon = styled(CloseOutlined)`
  position: absolute;
  top: 20px;
  right: 15px;
  z-index: 999;
`;
export const HelpRedirectWrapper = styled.div`
  position: absolute;
  top: 18px;
  right: 50px;
  z-index: 999;
`;

export const DimensionCreateContainer = styled.div`
  position: relative;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-width: 1000px;
  max-height: 100px;
  margin-bottom: 20px;
  background-color: #eee;
`;

export const DimensionCreateInput = styled(Input)`
  width: 180px;
`;

export const DimensionSelectInput = styled(Select)`
  width: 180px;
`;

export const CreateButton = styled.div`
  margin-bottom: 10px;
  margin-left: 10px;
`;
export const CloseCreationButton = styled(Button)`
  position: absolute;
  top: 1px;
  right: 10px;
  font-size: 12px;
  padding: 1px;
`;

export const CreateInfoButton = styled(Button)`
  position: absolute;
  top: 1px;
  left: 160px;
  font-size: 12px;
  padding: 1px;
`;

export const StartCreationButton = styled(Button)`
  position: relative;
  margin-bottom: 20px;
`;

export const DimensionCreateForm = styled(Form)`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-left: 7px;
`;

export const DropdownSpin = styled(Spin)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
`;

export const DimensionDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-wrap: break-word;
  white-space: normal;
  max-width: 100%;
  flex-wrap: wrap;
`;

export const DimensionSpan = styled.span`
  flex: 1;
  max-width: calc(100% - 30px);
  word-break: break-word;
`;
